import { Navigate, useRoutes } from 'react-router-dom';
import { lazy } from 'react';

// routes
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import StandaloneRoutes from './StandaloneRoutes';
import Loadable from 'ui-component/Loadable';

// 404 page
const NotFound = Loadable(lazy(() => import('views/pages/maintenance/NotFound')));

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([
    { path: '/', element: <Navigate to="/login" /> },
    StandaloneRoutes,
    LoginRoutes,
    MainRoutes,
    { path: '*', element: <NotFound /> }
  ]);
}
